import type { Currency, VisaForm } from "~/types";
import { getApplicableVariations } from "./visa-form";

interface CalcTotalPriceOptions { skipDiscount?: boolean; }

export function calcTotalPrice(form: VisaForm, currency: Currency, options: CalcTotalPriceOptions = {}) {
  const { product, discount, quantity } = form;
  const price = product.price[currency];
  let total = price * quantity;
  total += calcUrgency(form, currency);
  total += calcVariationFees(form, currency);
  if (discount && !options.skipDiscount) {
    total -= calcDiscount(total, discount);
  }
  return total;
}

export function calcVariationFees(form: VisaForm, currency: Currency) {
  const applicableVariations = getApplicableVariations(form);
  return applicableVariations.reduce((sum, variation) => {
    if (variation.type != 'fee') return sum;
    return form.applicants.reduce(sum => sum + variation.fee[currency], sum);
  }, 0);
}

export function calcUrgency(form: VisaForm, currency: Currency) {
  if (form.urgency == 'none') return 0;
  if (!form.product.urgencies) {
    throw new Error('Basket has urgency but product does not.');
  }
  const urgency = form.product.urgencies.find(u => u.speed == form.urgency);
  if (!urgency) {
    throw new Error('Urgency not found in product.');
  }
  return urgency.fee[currency] * form.quantity;
}

export function calcDiscount(price: number, discount: VisaForm['discount']) {
  if (!discount) return 0;
  if (discount.percent < 0 || discount.percent > 100) {
    throw new Error('Discount percent must be between 0 and 100.');
  }
  const amount = price * (discount.percent / 100);
  return Math.ceil(amount);
}

export function calcCommission(price: number, percent: number) {
  return Math.floor(price * (percent / 100));
}